import * as TYPES from './actions/types';

export const initialState = {
  externalSystems: null,
  userSelectedASystem: false,
};

const externalSystemsReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.USER_SELECTED_EXTERNAL_SYSTEM:
      newState = { ...state, ...action.state };
      break;
    case TYPES.EXTERNAL_SYSTEMS_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.EXTERNAL_SYSTEMS_LOADED_FAILED:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default externalSystemsReducer;
